import React, { useLayoutEffect, useState } from 'react'
import { createPortal } from 'react-dom'

export const SECTION_TABS_SLOT_ID = 'section-tabs-slot'

interface InElementSlotProps {
    slotId: string
    children: React.ReactNode
}

export function InElementSlot({ slotId, children }: InElementSlotProps) {
    const [slot, setSlot] = useState<HTMLElement | null>(null)
    useLayoutEffect(() => setSlot(document.getElementById(slotId)), [slotId])

    return slot ? createPortal(children, slot) : <>{children}</>
}

interface InSectionTabsSlotProps {
    children: React.ReactNode
}

export function InSectionTabsSlot({ children }: InSectionTabsSlotProps) {
    return <InElementSlot slotId={SECTION_TABS_SLOT_ID}>{children}</InElementSlot>
}

export default InSectionTabsSlot
